import {Language} from '..';

export const isLanguage = (language: string): language is Language => {
  return Object.keys(Language).includes(language);
}